import React from 'react';
import './Hero.css';
import HeroContactForm from '../HeroContactForm/HeroContactForm';
import LicensedInsured from '../Badges/LicensedInsured';
import Warranty from '../Badges/Warranty';


const Hero = () => {
  return (
    <div className='hero-wrapper'>
      <div className='hero-content-wrapper'>
        <div className='hero-content'>
          <div className='hero-text'>

            {/* Badges Row */}
            <div className="hero-badges">
              
              {/*<Warranty />*/}
              <LicensedInsured />
              
            </div>

            <div className='hero-text-header'>
              <p>
                <span>
                  Professional Gutter Installation & Cleaning in Ocala, The Villages, and Across Central Florida
                </span>
              </p>
            </div>

            <p className="hero-supporting-text">
              Family-owned and 5-star rated, we provide seamless gutters, gutter guards, and downspout services — all backed by fast, free estimates.
            </p>

            <div className='estimate-button-wrapper'>
              <a
                href="tel:352-812-0831"
                aria-label="Call Watkins Seamless Gutters"
                className='estimate-button'
              >
                <span className="text">Call Us Today!</span>
              </a>
            </div>
          </div>

          <div className='form-background'>
            <div className='form-container'>
              <div className='hero-form-header'>
                <p><span>Free No-Obligation Estimate!</span></p>
              </div>
              <div className='form-content-wrapper'>
                <HeroContactForm apiUrl={process.env.REACT_APP_API_URL} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
